import { GridLocaleText } from '@mui/x-data-grid';

const isBrowser = typeof window !== 'undefined';
const envData = isBrowser ? (window as any).__ENV__ || {} : process.env;

export const CurrentEnv = {
  APP_ID: envData?.APP_ID || envData?.NEXT_PUBLIC_APP_ID || '',
  HOSPITAL_ID: undefined,
  BASE_WEB: envData?.BASE_WEB || envData?.NEXT_PUBLIC_BASE_WEB || '',
  API_BE: envData?.API_BE || envData?.NEXT_PUBLIC_API_BE || '',
};

export const NameHosPital = '';
export const TAB_KEYS = {
  patient: 'patient',
  booking: 'booking',
  confirm: 'confirm',
  payment: 'payment',
};

const BOOKING_MESSAGE = {
  CREATED: 'Đặt khám thành công',
  WAITING_CONFIRM: 'Chưa thanh toán',
  NOT_CONFIRMED: 'Không được xác nhận',
  CONFIRMED: 'Đã Thanh Toán',
  CANCELED: 'Đã hủy',
  DELIVERIED: 'Đã khám',
};

export const STATUS = {
  created: {
    txt: BOOKING_MESSAGE.CREATED,
    color: '#3CAAAA',
    color_outner: '#3CAAAA',
  },
  waiting_confirmed: {
    txt: BOOKING_MESSAGE.WAITING_CONFIRM,
    color: '',
    color_outner: '#FF2F61',
  },
  unconfirmed: {
    txt: BOOKING_MESSAGE.NOT_CONFIRMED,
    color: '',
    color_outner: '#3CAAAA',
  },
  confirmed: {
    txt: BOOKING_MESSAGE.CONFIRMED,
    color: '',
    color_outner: '#3CAAAA',
  },
  canceled: {
    txt: BOOKING_MESSAGE.CANCELED,
    color: '#FF2F61',
    color_outner: '#A2AFC2',
  },
  deliveried: {
    txt: BOOKING_MESSAGE.DELIVERIED,
    color: '',
    color_outner: '#3CAAAA',
  },
  null: {
    txt: '',
    color: '',
    color_outner: '#3CAAAA',
  },
};

export enum FLOW_KEY {
  hospital = 'hospital',
  patient = 'patient',
  subject = 'subject',
  doctor = 'doctor',
  service = 'service',
  date = 'date',
  time = 'time',
}
export type FLowKeyType = keyof typeof FLOW_KEY;

export const FLOW = {
  hospital: ['hospital', 'patient', 'subject', 'service', 'date', 'time'],
  doctor: ['patient', 'doctor', 'subject', 'service', 'date', 'time'],
  subject: ['patient', 'subject', 'doctor', 'service', 'date', 'time'],
};

export type FlowType = 'subject' | 'doctor';

export const GLOBAL_TEXT = {
  YET_VALUE: 'Chưa cập nhật',
  MISS_VALUE: 'Không có dữ liệu',
  PROCESSING_LOADING: 'Tiến trình đang thực hiện',
  REQUIRE_DATA: 'Không được trống!',
  FEATURE_IN_DEVELOPMENT: 'Tính năng đăng được phát triển !',
};

export const option_sex = [
  {
    code: 0,
    name: 'Nữ',
  },
  {
    code: 1,
    name: 'Nam',
  },
];

export const _txt = {
  hidden: 'hidden',
  show: 'show',
  miss_value: 'Chưa cập nhật',
  processing_loading: 'Tiến trình đang thực hiện',
  require_value: 'không được trống!',
  feature_in_development: 'Tính năng đang được phát triển !',
};

export const _FDate = {
  '/DMY': 'DD/MM/YYYY',
  '/DM': 'DD/MM',
  '/DMYHM': 'DD/MM/YYYY HH:mm',
  '/DMYHMS': 'DD/MM/YYYY HH:mm:ss',
  '/HMDMY': 'HH:mm DD/MM/YYYY',
  '-/HMDMY': 'HH:mm - DD/MM/YYYY',
  '/YMD': 'YYYY/MM/DD',
  '/YMDHM': 'YYYY/MM/DD HH:mm',
  '/YMDHMS': 'YYYY/MM/DD HH:mm:ss',
  '-DMY': 'DD-MM-YYYY',
  '-DMYHM': 'DD-MM-YYYY HH:mm',
  '-YMD': 'YYYY-MM-DD',
  '-YMDHM': 'YYYY-MM-DD HH:mm',
  '-YMDHMS': 'YYYY-MM-DD HH:mm:ss',
  ':HHmm': 'HH:mm',
} as const;

export const rowsPerPageOptions = [5, 10, 20, 50, 100];

export const FIELD_STATUS = [
  { name: 'Bản nháp', value: 'draft' },
  { name: 'Xuất bản', value: 'published' },
];

// src/locales/viVNDataGridLocale.ts

export const slugifyOptions = {
  replacement: '-', // replace spaces with replacement character, defaults to `-`
  remove: undefined, // remove characters that match regex, defaults to `undefined`
  lower: false, // convert to lower case, defaults to `false`
  strict: false, // strip special characters except replacement, defaults to `false`
  locale: 'vi', // language code of the locale to use
  trim: true, // trim leading and trailing replacement chars, defaults to `true`
};

export const viVNDataGridLocale: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'Không có dữ liệu',
  noResultsOverlayLabel: 'Không tìm thấy kết quả phù hợp.',
  errorOverlayDefaultLabel: 'Đã xảy ra lỗi.',

  // Density selector toolbar button text
  toolbarDensity: 'Mật độ',
  toolbarDensityLabel: 'Mật độ hiển thị',
  toolbarDensityCompact: 'Gọn',
  toolbarDensityStandard: 'Tiêu chuẩn',
  toolbarDensityComfortable: 'Thoáng',

  // Columns selector toolbar button text
  toolbarColumns: 'Cột dữ liệu',
  toolbarColumnsLabel: 'Chọn cột hiển thị',

  // Filters toolbar button text
  toolbarFilters: 'Bộ lọc',
  toolbarFiltersLabel: 'Hiển thị bộ lọc',
  toolbarFiltersTooltipHide: 'Ẩn bộ lọc',
  toolbarFiltersTooltipShow: 'Hiện bộ lọc',
  toolbarFiltersTooltipActive: (count: number) => `${count} bộ lọc đang bật`,

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: 'Tìm kiếm…',
  toolbarQuickFilterLabel: 'Tìm nhanh',
  toolbarQuickFilterDeleteIconLabel: 'Xoá',

  // Export selector toolbar button text
  toolbarExport: 'Xuất dữ liệu',
  toolbarExportLabel: 'Xuất dữ liệu',
  toolbarExportCSV: 'Xuất ra CSV',
  toolbarExportPrint: 'In dữ liệu',
  toolbarExportExcel: 'Xuất ra Excel',

  // Columns panel text
  columnsPanelTextFieldLabel: 'Tìm cột',
  columnsPanelTextFieldPlaceholder: 'Tên cột...',
  columnsPanelDragIconLabel: 'Sắp xếp lại cột',
  columnsPanelShowAllButton: 'Hiện tất cả',
  columnsPanelHideAllButton: 'Ẩn tất cả',

  // Filter panel text
  filterPanelAddFilter: 'Thêm bộ lọc',
  filterPanelDeleteIconLabel: 'Xoá',
  filterPanelLinkOperator: 'Điều kiện logic',
  filterPanelOperators: 'Toán tử so sánh',
  filterPanelOperatorAnd: 'Và',
  filterPanelOperatorOr: 'Hoặc',
  filterPanelColumns: 'Cột',
  filterPanelInputLabel: 'Giá trị',
  filterPanelInputPlaceholder: 'Giá trị lọc...',

  // Filter operators text
  filterOperatorContains: 'chứa',
  filterOperatorEquals: 'bằng',
  filterOperatorStartsWith: 'bắt đầu bằng',
  filterOperatorEndsWith: 'kết thúc bằng',
  filterOperatorIs: 'là',
  filterOperatorNot: 'không là',
  filterOperatorAfter: 'sau',
  filterOperatorOnOrAfter: 'trên hoặc sau',
  filterOperatorBefore: 'trước',
  filterOperatorOnOrBefore: 'trên hoặc trước',
  filterOperatorIsEmpty: 'rỗng',
  filterOperatorIsNotEmpty: 'không rỗng',

  // Column menu text
  columnMenuLabel: 'Menu cột',
  columnMenuShowColumns: 'Hiển thị cột',
  columnMenuFilter: 'Bộ lọc',
  columnMenuHideColumn: 'Ẩn cột',
  columnMenuUnsort: 'Bỏ sắp xếp',
  columnMenuSortAsc: 'Sắp xếp tăng dần',
  columnMenuSortDesc: 'Sắp xếp giảm dần',

  // Column header text
  columnHeaderFiltersTooltipActive: (count: number) => `${count} bộ lọc đang bật`,
  columnHeaderFiltersLabel: 'Hiển thị bộ lọc',
  columnHeaderSortIconLabel: 'Sắp xếp',

  // Rows selected footer text
  footerRowSelected: (count: number) => `${count.toLocaleString()} dòng được chọn`,

  // Total rows footer text
  footerTotalRows: 'Tổng số dòng:',

  // Checkbox selection text
  checkboxSelectionHeaderName: 'Chọn',

  // Boolean cell text
  booleanCellTrueLabel: 'Có',
  booleanCellFalseLabel: 'Không',

  // Actions cell text
  actionsCellMore: 'Thêm hành động',

  // Tree Data
  treeDataGroupingHeaderName: 'Nhóm',
  treeDataExpand: 'Mở rộng',
  treeDataCollapse: 'Thu gọn',

  // Grouping columns
  groupingColumnHeaderName: 'Nhóm',
  groupColumn: (name: string) => `Nhóm theo ${name}`,
  unGroupColumn: (name: string) => `Bỏ nhóm theo ${name}`,

  // Mui pagination
  MuiTablePagination: {
    labelRowsPerPage: 'Dòng mỗi trang:',
    labelDisplayedRows: ({ from, to, count }: any) =>
      `${from}–${to} trên ${count !== -1 ? count : `hơn ${to}`}`,
  },
};
